var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-row',[_c('v-col',[(_vm.showErrorComponent)?_c('error-message'):_c('document-templates-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }